import React, { useState } from "react";
import Seo from "./Seo";

function DownloadsBook() {
  const [activeCategory, setActiveCategory] = useState('all');

  const books = [
    {
      id: 1,
      title: "Black Hat Python",
      subtitle: "Python Programming for Hackers and Pentesters",
      link: "/files/Black Hat Python Python Programming for Hackers and Pentesters.pdf",
      category: "security",
      pages: "195"
    },
    {
      id: 2,
      title: "Basics of Penetration Testing",
      subtitle: "Getting Started with Security Assessment",
      link: "/files/Basics of Penetration Testing.pdf",
      category: "security",
      pages: "180"
    },
    {
      id: 3,
      title: "Metasploit",
      subtitle: "The Penetration Tester's Guide",
      link: "/files/Metasploit The Penetration Tester s Guide.pdf",
      category: "security",
      pages: "331"
    },
    {
      id: 4,
      title: "The DevOps Handbook",
      subtitle: "Creating World-Class Agility, Reliability & Security",
      link: "/files/The DevOps Handbook.pdf",
      category: "devops",
      pages: "480"
    },
    {
      id: 5,
      title: "TypeScript Fundamentals",
      subtitle: "Essential TypeScript for Developers",
      link: "/files/Typescript Fundamentals.pdf",
      category: "programming",
      pages: "120"
    },
    {
      id: 6,
      title: "Ubuntu Linux Unleashed",
      subtitle: "2021 Edition, 14th Edition",
      link: "/files/Ubuntu Linux Unleashed 2021 Edition 14th Edition.pdf",
      category: "linux",
      pages: "912"
    },
    {
      id: 7,
      title: "The Linux Command Line",
      subtitle: "A Complete Introduction",
      link: "/files/The Linux Command Line.pdf",
      category: "linux",
      pages: "480"
    },
    {
      id: 8,
      title: "TCP/IP Foundations",
      subtitle: "Network Protocol Fundamentals",
      link: "/files/TCP IP Foundations.pdf",
      category: "networking",
      pages: "285"
    },
    {
      id: 9,
      title: "Linux Command Line & Shell Scripting Bible",
      subtitle: "Comprehensive Shell Programming Guide",
      link: "/files/Linux Command Line And Shell Scripting Bible.pdf",
      category: "linux",
      pages: "816"
    },
    {
      id: 10,
      title: "Linux Bible",
      subtitle: "10th Edition 2020",
      link: "/files/Linux Bible 10th-ed 2020.pdf",
      category: "linux",
      pages: "928"
    },
  ];

  const categories = [
    { id: 'all', label: 'All Resources', count: books.length },
    { id: 'linux', label: 'Linux', count: books.filter(b => b.category === 'linux').length },
    { id: 'security', label: 'Security', count: books.filter(b => b.category === 'security').length },
    { id: 'devops', label: 'DevOps', count: books.filter(b => b.category === 'devops').length },
    { id: 'programming', label: 'Programming', count: books.filter(b => b.category === 'programming').length },
    { id: 'networking', label: 'Networking', count: books.filter(b => b.category === 'networking').length },
  ];

  const filteredBooks = activeCategory === 'all' 
    ? books 
    : books.filter(book => book.category === activeCategory);

  const getCategoryColor = (category) => {
    const colors = {
      linux: { bg: 'rgba(34, 197, 94, 0.1)', text: '#16a34a', border: 'rgba(34, 197, 94, 0.3)' },
      security: { bg: 'rgba(239, 68, 68, 0.1)', text: '#dc2626', border: 'rgba(239, 68, 68, 0.3)' },
      devops: { bg: 'rgba(59, 130, 246, 0.1)', text: '#2563eb', border: 'rgba(59, 130, 246, 0.3)' },
      programming: { bg: 'rgba(168, 85, 247, 0.1)', text: '#9333ea', border: 'rgba(168, 85, 247, 0.3)' },
      networking: { bg: 'rgba(245, 158, 11, 0.1)', text: '#d97706', border: 'rgba(245, 158, 11, 0.3)' },
    };
    return colors[category] || colors.linux;
  };

  return (
    <div className="downloads-container">
      <Seo
        title="Downloads - LinuxSecOps"
        description="Free technical PDF resources on Linux, security testing, DevOps practices, networking, and software development."
        path="/downloads"
      />

      {/* Hero */}
      <section className="downloads-hero">
        <div className="downloads-hero-content">
          <span className="downloads-hero-badge">Free Resources</span>
          <h1 className="downloads-hero-title">
            Technical Library
            <span className="downloads-hero-accent">PDF Downloads</span>
          </h1>
          <p className="downloads-hero-description">
            Curated collection of technical books and guides for Linux administration, 
            security testing, DevOps practices, and software development.
          </p>
          <div className="downloads-hero-stats">
            <div className="downloads-stat">
              <span className="downloads-stat-value">{books.length}</span>
              <span className="downloads-stat-label">Resources</span>
            </div>
            <div className="downloads-stat-divider"></div>
            <div className="downloads-stat">
              <span className="downloads-stat-value">PDF</span>
              <span className="downloads-stat-label">Format</span>
            </div>
            <div className="downloads-stat-divider"></div>
            <div className="downloads-stat">
              <span className="downloads-stat-value">Free</span>
              <span className="downloads-stat-label">Access</span>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="downloads-content">
        {/* Filter */}
        <div className="downloads-filter">
          {categories.map(cat => (
            <button
              key={cat.id}
              className={`downloads-filter-btn ${activeCategory === cat.id ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat.id)}
            >
              {cat.label}
              <span className="downloads-filter-count">{cat.count}</span>
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="downloads-grid">
          {filteredBooks.map((book) => {
            const colors = getCategoryColor(book.category);
            return (
              <a 
                key={book.id} 
                href={book.link} 
                download 
                className="download-card"
              >
                <div className="download-card-header">
                  <div className="download-card-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                      <polyline points="14 2 14 8 20 8"/>
                      <line x1="16" y1="13" x2="8" y2="13"/>
                      <line x1="16" y1="17" x2="8" y2="17"/>
                      <polyline points="10 9 9 9 8 9"/>
                    </svg>
                  </div>
                  <span 
                    className="download-card-category"
                    style={{ 
                      background: colors.bg, 
                      color: colors.text,
                      border: `1px solid ${colors.border}`
                    }}
                  >
                    {book.category}
                  </span>
                </div>
                <h3 className="download-card-title">{book.title}</h3>
                <p className="download-card-subtitle">{book.subtitle}</p>
                <div className="download-card-footer">
                  <span className="download-card-pages">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                    </svg>
                    {book.pages} pages
                  </span>
                  <span className="download-card-action">
                    Download
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                      <polyline points="7 10 12 15 17 10"/>
                      <line x1="12" y1="15" x2="12" y2="3"/>
                    </svg>
                  </span>
                </div>
              </a>
            );
          })}
        </div>

        {/* Note */}
        <div className="downloads-note">
          <div className="downloads-note-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 16v-4"/>
              <path d="M12 8h.01"/>
            </svg>
          </div>
          <div className="downloads-note-content">
            <strong>Educational Use:</strong> These resources are shared for educational purposes. 
            Please respect copyright and support authors by purchasing official copies when possible.
          </div>
        </div>
      </section>
    </div>
  );
}

export default DownloadsBook;
